import { Autocomplete, Grid, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Entity from '../../../v3/Common/Entity';

const IndustryAndCompanyPicker = () => {
  const dispatch = useDispatch();

  // Get manufacturer and entity from Redux via Entity component
  const { selectedSupplier, selectedEntity, selectedSupplierData } = useSelector(
    (state) => state.entityReducer
  );

  // Auto-dispatch when supplier changes
  useEffect(() => {
    if (selectedSupplier && selectedSupplierData) {
      dispatch({
        type: 'SET_COMPANY_DETAILS_REPORT_REDUCER',
        data: selectedSupplierData,
      });
    }
  }, [selectedSupplier, selectedSupplierData, dispatch]);
  // Auto-dispatch when entity changes
  useEffect(() => {
    if (selectedEntity) {
      dispatch({
        type: 'SET_COMPANY_ENTITY_ID_REDUCER',
        data: selectedEntity,
      });
    }
  }, [selectedEntity, dispatch]);
  return (
    <Entity
      supplierLabel="Manufacturer"
      entityLabel="SAP Code"
      forceRefresh={false}
    />
  );
};

export default IndustryAndCompanyPicker;
